import InteriorQuestionsPage from './components/InteriorQuestionsRoute';
import { Navigate, Outlet, RouterProvider, createBrowserRouter, useOutletContext } from 'react-router-dom';
import ExteriorQuestionsPage from './components/ExteriorQuestionsRoute';
import { GoogleOAuthProvider } from '@react-oauth/google';
import LoginWrapper from './components/LoginWrapper';
import { AdminQuestionServiceClient } from './protos/adminbackendproto/AdminQuestionServiceServiceClientPb';
import { AdminNewsletterServiceClient } from './protos/adminbackendproto/AdminNewsletterServiceServiceClientPb';
import BasementQuestionsPage from './components/BasementQuestionsRoute';
import NewsletterReviewPage from './components/NewsletterReviewRoute';


type ChildPageContext = { client: AdminQuestionServiceClient, newsletterClient: AdminNewsletterServiceClient, hasEditAccess: Boolean };

const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginWrapper children={(result) => {
      return <Outlet context={{ client: result.client, newsletterClient: result.newsletterClient, hasEditAccess: result.hasEditAccess }} />
    }} />,
    children: [
      {
        path: "/",
        element: <Navigate to="/interior" replace />,
      },
      {
        path: "/interior",
        element: <InteriorQuestionsPage />,
      },
      {
        path: "/exterior",
        element: <ExteriorQuestionsPage />,
      },
      {
        path: "/basement",
        element: <BasementQuestionsPage />,
      },
      {
        path: "/newsletters",
        element: <NewsletterReviewPage />,
      },
    ]
  },
]);

export function GetServiceClient() {
  return useOutletContext<ChildPageContext>().client;
}

export function GetNewsletterServiceClient() {
  return useOutletContext<ChildPageContext>().newsletterClient;
}

export function GetHasEditAccess() {
  return useOutletContext<ChildPageContext>().hasEditAccess;
}

function App() {
  return (
    <GoogleOAuthProvider clientId="24344207773-h1hetjgv5nuft2ascsi16fo8mup2v8cp.apps.googleusercontent.com">
      <RouterProvider router={router} />
    </GoogleOAuthProvider>
  );
}

export default App;
